/* ZelaSkin — interacciones (vanilla, sin librerías) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Animaciones de entrada ---------- */
  var io = null;
  function initReveals(scope) {
    var els = (scope || document).querySelectorAll('.zs-reveal:not(.zs-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('zs-visible'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('zs-visible');
          io.unobserve(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave ---------- */
  function initParallax() {
    var items = document.querySelectorAll('[data-zs-parallax]');
    if (!items.length || reduceMotion) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      items.forEach(function (el) {
        var fuerza = parseFloat(el.getAttribute('data-zs-parallax')) || 0;
        if (!fuerza) return;
        var r = el.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var centro = (r.top + r.height / 2 - vh / 2) / vh;
        el.style.transform = 'translate3d(0,' + (centro * fuerza * -1).toFixed(1) + 'px,0) scale(1.08)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- 7 luces: la máscara cambia de color ---------- */
  function initLuces() {
    document.querySelectorAll('[data-zs-luces]').forEach(function (root) {
      if (root.dataset.zsListo) return;
      root.dataset.zsListo = '1';
      var escena = root.querySelector('[data-zs-escena]');
      var nombre = root.querySelector('[data-zs-luz-nombre]');
      var botones = Array.prototype.slice.call(root.querySelectorAll('[data-zs-luz]'));
      if (!escena || !botones.length) return;
      var segundos = parseInt(root.getAttribute('data-zs-auto'), 10) || 0;
      var timer = null, actual = 0;

      function activar(i) {
        actual = (i + botones.length) % botones.length;
        var b = botones[actual];
        escena.style.setProperty('--zs-luz', b.getAttribute('data-zs-luz'));
        if (nombre) nombre.textContent = b.getAttribute('data-zs-luz-titulo');
        botones.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      }
      function auto() {
        if (!segundos || reduceMotion) return;
        clearInterval(timer);
        timer = setInterval(function () { activar(actual + 1); }, segundos * 1000);
      }
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () { activar(i); clearInterval(timer); });
        b.addEventListener('mouseenter', function () {
          if (window.matchMedia('(hover: hover)').matches) { activar(i); clearInterval(timer); }
        });
      });
      root.addEventListener('mouseleave', auto);
      activar(0);
      auto();
    });
  }

  /* ---------- Página de producto ---------- */
  function initProducto() {
    document.querySelectorAll('[data-zs-producto]').forEach(function (root) {
      if (root.dataset.zsListo) return;
      root.dataset.zsListo = '1';
      initGaleria(root);
      initFormatos(root);
      initCantidad(root);
      initBarra(root);
    });
  }

  function indiceActual(root) {
    var minis = Array.prototype.slice.call(root.querySelectorAll('[data-zs-mini]'));
    var i = minis.findIndex(function (b) { return b.getAttribute('aria-current') === 'true'; });
    return i < 0 ? 0 : i;
  }

  function cambiarImagen(root, src, srcset, alt, btnActivo) {
    var principal = root.querySelector('[data-zs-principal]');
    if (!principal || !src || principal.tagName !== 'IMG') return;
    principal.style.opacity = '0';
    setTimeout(function () {
      principal.src = src;
      if (srcset) principal.srcset = srcset; else principal.removeAttribute('srcset');
      if (alt !== null && alt !== undefined) principal.alt = alt;
      principal.style.opacity = '1';
    }, 180);
    var contador = root.querySelector('[data-zs-contador]');
    root.querySelectorAll('[data-zs-mini]').forEach(function (b, i) {
      b.setAttribute('aria-current', b === btnActivo ? 'true' : 'false');
      if (b === btnActivo && contador) contador.textContent = i + 1;
    });
  }

  function irA(root, i) {
    var minis = root.querySelectorAll('[data-zs-mini]');
    if (!minis.length) return;
    i = (i + minis.length) % minis.length;
    var btn = minis[i];
    cambiarImagen(root, btn.getAttribute('data-zs-src'), btn.getAttribute('data-zs-srcset'), btn.getAttribute('data-zs-alt'), btn);
  }

  function initGaleria(root) {
    var principal = root.querySelector('[data-zs-principal]');
    var zona = root.querySelector('[data-zs-zona]');
    if (!principal || !zona) return;
    root.querySelectorAll('[data-zs-mini]').forEach(function (btn, i) {
      btn.addEventListener('click', function () { irA(root, i); });
    });
    root.querySelectorAll('[data-zs-flecha]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.stopPropagation();
        irA(root, indiceActual(root) + parseInt(b.getAttribute('data-zs-flecha'), 10));
      });
    });
    var x0 = null, y0 = null;
    zona.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    zona.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) irA(root, indiceActual(root) + (dx < 0 ? 1 : -1));
      x0 = null;
    });
    if (zona.classList.contains('zs-prod__principal--zoom') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      zona.addEventListener('mousemove', function (e) {
        var r = zona.getBoundingClientRect();
        principal.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
        principal.classList.add('zs-zoom-activo');
      });
      zona.addEventListener('mouseleave', function () { principal.classList.remove('zs-zoom-activo'); });
    }
    initLightbox(root, zona);
  }

  function initLightbox(root, zona) {
    var lb = root.querySelector('[data-zs-lightbox]');
    var dataEl = root.querySelector('[data-zs-galeria]');
    if (!lb || !dataEl) return;
    var fotos;
    try { fotos = JSON.parse(dataEl.textContent); } catch (e) { return; }
    if (!fotos.length) return;
    document.body.appendChild(lb);
    var img = lb.querySelector('[data-zs-lb-img]');
    var lienzo = lb.querySelector('[data-zs-lb-lienzo]');
    var actual = 0, ampliada = false, ultimoFoco = null;
    function mostrar(i) {
      actual = (i + fotos.length) % fotos.length;
      img.src = fotos[actual].big;
      img.alt = fotos[actual].alt;
      ampliada = false;
      img.classList.remove('zs-lb-ampliada');
    }
    function abrir() {
      ultimoFoco = document.activeElement;
      mostrar(indiceActual(root));
      lb.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      lb.querySelector('[data-zs-cerrar]').focus();
    }
    function cerrar() {
      lb.hidden = true;
      document.documentElement.style.overflow = '';
      irA(root, actual);
      if (ultimoFoco) ultimoFoco.focus();
    }
    zona.addEventListener('click', function (e) {
      if (e.target.closest('[data-zs-flecha]')) return;
      abrir();
    });
    lb.querySelector('[data-zs-cerrar]').addEventListener('click', cerrar);
    lb.querySelectorAll('[data-zs-lb-flecha]').forEach(function (b) {
      b.addEventListener('click', function () { mostrar(actual + parseInt(b.getAttribute('data-zs-lb-flecha'), 10)); });
    });
    lienzo.addEventListener('click', function (e) {
      if (e.target !== img) { cerrar(); return; }
      var r = img.getBoundingClientRect();
      img.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      ampliada = !ampliada;
      img.classList.toggle('zs-lb-ampliada', ampliada);
    });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowRight') mostrar(actual + 1);
      if (e.key === 'ArrowLeft') mostrar(actual - 1);
    });
  }

  function dinero(root, cent) {
    var formato = root.getAttribute('data-zs-moneda') || '';
    var n = (cent / 100).toFixed(2);
    if (!formato) return n.replace('.', ',') + ' €';
    if (/amount_with_comma_separator/.test(formato)) n = n.replace('.', ',');
    if (/amount_no_decimals/.test(formato)) n = String(Math.round(cent / 100));
    return formato.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, n);
  }

  function initFormatos(root) {
    var dataEl = root.querySelector('[data-zs-variantes]');
    if (!dataEl) return;
    var variantes;
    try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var input = root.querySelector('form input[name="id"]');
    var textoBoton = root.getAttribute('data-zs-texto-boton') || '';
    var textoAgotado = root.getAttribute('data-zs-texto-agotado') || '';
    // Solo los elementos de ESTE producto (y su barra fija), por si hay varios productos en la misma página
    function todos(sel) {
      var a = Array.prototype.slice.call(root.querySelectorAll(sel));
      if (root._zsBarra) a = a.concat(Array.prototype.slice.call(root._zsBarra.querySelectorAll(sel)));
      return a;
    }

    function actualizar(id) {
      var v = variantes.find(function (x) { return String(x.id) === String(id); });
      if (!v) return;
      if (input) input.value = v.id;
      var hayAntes = v.compare_at_price && v.compare_at_price > v.price;
      var pct = hayAntes ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
      todos('[data-zs-precio]').forEach(function (p) { p.textContent = dinero(root, v.price); });
      todos('[data-zs-precio-antes]').forEach(function (a) { a.hidden = !hayAntes; if (hayAntes) a.textContent = dinero(root, v.compare_at_price); });
      todos('[data-zs-ahorro]').forEach(function (a) {
        a.hidden = !hayAntes;
        if (hayAntes) a.textContent = a.getAttribute('data-zs-ahorro').replace('[x]', pct).replace('[euros]', dinero(root, v.compare_at_price - v.price));
      });
      todos('[data-zs-pct]').forEach(function (a) { a.textContent = pct; });
      todos('[data-zs-boton-compra]').forEach(function (b) {
        b.disabled = !v.available;
        var span = b.querySelector('[data-zs-boton-texto]');
        if (span) span.textContent = v.available ? (span.getAttribute('data-zs-texto') || textoBoton) : textoAgotado;
      });
      var agotado = root.querySelector('[data-zs-agotado]');
      if (agotado) agotado.hidden = !!v.available;
      if (v.featured_media_src) {
        var mini = root.querySelector('[data-zs-mini][data-zs-media-id="' + v.featured_media_id + '"]');
        cambiarImagen(root, v.featured_media_src, '', null, mini);
      }
      if (document.querySelectorAll('[data-zs-producto]').length === 1) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    root.querySelectorAll('[data-zs-formato]').forEach(function (r) {
      r.addEventListener('change', function () { if (r.checked) actualizar(r.value); });
    });
  }

  function initCantidad(root) {
    root.querySelectorAll('[data-zs-cantidad]').forEach(function (wrap) {
      var input = wrap.querySelector('input');
      wrap.querySelectorAll('[data-zs-cambio]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, v + parseInt(b.getAttribute('data-zs-cambio'), 10));
        });
      });
    });
  }

  function initBarra(root) {
    var barra = root.querySelector('[data-zs-barra]');
    var ancla = root.querySelector('[data-zs-ancla-compra]');
    if (!barra || !ancla || !('IntersectionObserver' in window)) return;
    root._zsBarra = barra;
    document.body.appendChild(barra);
    document.body.classList.add('zs-con-barra');
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        barra.classList.toggle('zs-barra--visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    });
    obs.observe(ancla);
    barra.querySelectorAll('[data-zs-ir-compra]').forEach(function (btn) {
      btn.addEventListener('click', function (ev) {
        var form = root.querySelector('form[action*="/cart/add"]');
        if (!form) return;
        ev.preventDefault();
        var submitter = form.querySelector('button[name="add"]');
        if (submitter && submitter.disabled) return;
        if (form.requestSubmit) { form.requestSubmit(submitter || undefined); } else { form.submit(); }
      });
    });
  }

  /* ---------- FAQ: una abierta a la vez ---------- */
  function initFaq() {
    document.querySelectorAll('[data-zs-faq-unica]').forEach(function (lista) {
      var items = lista.querySelectorAll('details');
      items.forEach(function (d) {
        d.addEventListener('toggle', function () {
          if (!d.open) return;
          items.forEach(function (o) { if (o !== d) o.open = false; });
        });
      });
    });
  }

  /* ---------- Judge.me: textos que la app deja en inglés ---------- */
  var TRADUCCIONES = {
    'Be the first to write a review': 'Aún no hay opiniones. ¡Sé la primera en contarnos qué te parece!',
    'Write a review': 'Escribir una opinión',
    'Customer Reviews': 'Opiniones de clientas',
    'No reviews': 'Sin opiniones todavía',
    'See all reviews': 'Ver todas las opiniones',
    'How would you rate this product?': '¿Qué nota le das a este producto?',
    'We would love it if you would share a bit about your experience.': 'Nos encantaría que nos contaras tu experiencia.',
    'Review content (Required)': 'Tu opinión (obligatorio)',
    'About you': 'Sobre ti',
    'Please tell us more about you.': 'Cuéntanos un poco sobre ti.',
    'Email address (Required)': 'Correo electrónico (obligatorio)',
    'We respect your privacy.': 'Respetamos tu privacidad.',
    'Display name (Required)': 'Nombre que se mostrará (obligatorio)',
    "This won't be visible to other customers.": 'No se mostrará a otras clientas.',
    'Post review as anonymous': 'Publicar de forma anónima',
    'Share a picture or video': 'Comparte una foto o un vídeo',
    'Upload a photo or video to support your review.': 'Sube una foto o un vídeo para acompañar tu opinión.',
    'Click to upload': 'Pulsa para subir',
    'or drag and drop': 'o arrastra el archivo aquí',
    'Back': 'Atrás',
    'Next': 'Siguiente',
    'Submit': 'Enviar',
    'Submit Review': 'Enviar opinión',
    'Thanks for your review!': '¡Gracias por tu opinión!',
    'We are processing it and it will appear on the store soon.': 'La estamos revisando y aparecerá en la tienda muy pronto.',
    'Close': 'Cerrar',
    'This field is required': 'Este campo es obligatorio',
    'Start writing here...': 'Empieza a escribir aquí...',
    'Your email address': 'Tu correo electrónico',
    'Display name': 'Tu nombre',
    'Poor': 'Mala', 'Great': 'Excelente'
  };
  function traducirNodo(raiz) {
    if (!raiz) return;
    var walker = document.createTreeWalker(raiz, NodeFilter.SHOW_TEXT, null);
    var n;
    while ((n = walker.nextNode())) {
      var t = n.nodeValue.trim();
      if (t && TRADUCCIONES[t]) n.nodeValue = n.nodeValue.replace(t, TRADUCCIONES[t]);
    }
    if (raiz.querySelectorAll) raiz.querySelectorAll('[aria-label], [placeholder]').forEach(function (el) {
      ['aria-label', 'placeholder'].forEach(function (attr) {
        var a = el.getAttribute(attr);
        if (a && TRADUCCIONES[a]) el.setAttribute(attr, TRADUCCIONES[a]);
      });
    });
  }
  /* Reseñas en español primero (dentro de cada página de reseñas, sin mover nada: solo con CSS order) */
  var PALABRAS_ES = /\b(el|la|los|las|que|muy|es|está|con|para|pero|me|mi|lo|una|un|y|de|producto|calidad|recomiendo|llegó|piel)\b/gi;
  var PALABRAS_EN = /\b(the|and|is|it|very|this|my|with|for|but|was|love|great|skin|really)\b/gi;
  function esEspanol(texto) {
    if (!texto) return false;
    var es = (texto.match(PALABRAS_ES) || []).length + ((texto.match(/[ñáéíóú¿¡]/gi) || []).length ? 2 : 0);
    var en = (texto.match(PALABRAS_EN) || []).length;
    return es > en;
  }
  function marcarEspanol() {
    document.querySelectorAll('.jm-review-item').forEach(function (item) {
      var cuerpo = item.querySelector('.jdgm-review-content__body-content, .jm-review-content__body');
      var es = esEspanol(cuerpo ? cuerpo.textContent : '');
      var valor = es ? 'es' : 'otro';
      if (item.getAttribute('data-zs-idioma') !== valor) item.setAttribute('data-zs-idioma', valor);
    });
  }
  function initJudgeme() {
    if (!document.querySelector('.jdgm-widget') || !('MutationObserver' in window)) return;
    var pendiente = false;
    new MutationObserver(function () {
      if (pendiente) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        document.querySelectorAll('.jdgm-widget, .jdgm-write-review-modal, [class*="jm-review-form"]').forEach(traducirNodo);
        marcarEspanol();
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
    document.querySelectorAll('.jdgm-widget').forEach(traducirNodo);
    marcarEspanol();
  }

  /* ---------- Lista propia de reseñas: TODAS las del producto, español primero ---------- */
  function textoPlano(html) {
    var d = document.createElement('div');
    d.innerHTML = html || '';
    return (d.textContent || '').trim();
  }
  function fechaCorta(iso) {
    var f = new Date(iso);
    if (isNaN(f)) return '';
    return ('0' + f.getDate()).slice(-2) + '/' + ('0' + (f.getMonth() + 1)).slice(-2) + '/' + f.getFullYear();
  }
  function estrellasHTML(nota, clase) {
    var n = Math.round(parseFloat(nota) || 0), s = '';
    for (var i = 1; i <= 5; i++) s += i <= n ? '★' : '☆';
    return '<span class="' + clase + '" role="img" aria-label="' + n + ' de 5 estrellas">' + s + '</span>';
  }
  function crearTarjeta(r) {
    var art = document.createElement('article');
    art.className = 'zs-rev__item';
    var cuerpo = document.createElement('div');
    cuerpo.className = 'zs-rev__cuerpo';
    cuerpo.innerHTML = estrellasHTML(r.rating, 'zs-rev__estrellas');
    var quien = document.createElement('div');
    quien.className = 'zs-rev__quien';
    var ini = document.createElement('span');
    ini.className = 'zs-rev__inicial';
    ini.textContent = (r.reviewer_initial || (r.reviewer_name || '?').charAt(0)).toUpperCase();
    var datos = document.createElement('div');
    var nombre = document.createElement('strong');
    nombre.textContent = r.reviewer_name || '';
    var fecha = document.createElement('small');
    fecha.textContent = fechaCorta(r.created_at);
    datos.appendChild(nombre); datos.appendChild(fecha);
    quien.appendChild(ini); quien.appendChild(datos);
    cuerpo.appendChild(quien);
    if (r.title) { var t = document.createElement('p'); t.className = 'zs-rev__titulo'; t.textContent = r.title; cuerpo.appendChild(t); }
    var texto = document.createElement('p');
    texto.className = 'zs-rev__texto';
    texto.textContent = textoPlano(r.body_html);
    cuerpo.appendChild(texto);
    if (texto.textContent.length > 200) {
      var leer = document.createElement('button');
      leer.type = 'button';
      leer.className = 'zs-rev__leer';
      leer.textContent = 'Leer más';
      leer.addEventListener('click', function () {
        var abierto = art.classList.toggle('zs-rev__item--abierto');
        leer.textContent = abierto ? 'Leer menos' : 'Leer más';
      });
      cuerpo.appendChild(leer);
    }
    var foto = r.pictures_urls && r.pictures_urls[0];
    if (foto) {
      var a = document.createElement('a');
      a.className = 'zs-rev__foto';
      a.href = foto.huge || foto.original;
      a.target = '_blank'; a.rel = 'noopener';
      var img = document.createElement('img');
      img.src = foto.compact || foto.small || foto.original;
      img.alt = 'Foto de la reseña de ' + (r.reviewer_name || 'una clienta');
      img.loading = 'lazy';
      img.decoding = 'async';
      // Las fotos importadas de AliExpress pueden bloquearse si se envía el origen de la web
      img.referrerPolicy = 'no-referrer';
      // Si una foto no carga, la tarjeta se queda solo con el texto (sin hueco vacío)
      img.addEventListener('error', function () { if (a.parentNode) a.parentNode.removeChild(a); });
      a.appendChild(img);
      if (r.pictures_urls.length > 1) {
        var mas = document.createElement('span');
        mas.className = 'zs-rev__fotos-mas';
        mas.textContent = '+' + (r.pictures_urls.length - 1);
        a.appendChild(mas);
      }
      art.appendChild(a);
    }
    art.appendChild(cuerpo);
    return art;
  }
  /* Todas las reseñas (publicadas) de uno o varios productos, con total y nota media conjunta */
  var cacheResenas = {};
  function resenasDeProductos(ids, dominio) {
    var clave = ids.join(',') + '@' + dominio;
    if (cacheResenas[clave]) return cacheResenas[clave];
    function pagina(id, n) {
      return fetch('https://cdn.judge.me/reviews/reviews_for_widget?product_id=' + id + '&per_page=30&sort_by=created_at&sort_dir=desc&shop_domain=' + encodeURIComponent(dominio) + '&platform=shopify&page=' + n + '&v=' + Math.floor(Date.now() / 600000))  // v: evita copias viejas de más de 10 min
        .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); });
    }
    function deUno(id) {
      return pagina(id, 1).then(function (j) {
        var total = (j.pagination && j.pagination.total_pages) || 1, extra = [];
        for (var p = 2; p <= Math.min(total, 50); p++) extra.push(pagina(id, p));
        return Promise.all(extra).then(function (mas) {
          var lista = (j.reviews || []).slice();
          mas.forEach(function (m) { lista = lista.concat(m.reviews || []); });
          return { reviews: lista, n: parseInt(j.number_of_reviews, 10) || lista.length, media: parseFloat(j.average_rating) || 0 };
        });
      }).catch(function () { return { reviews: [], n: 0, media: 0 }; });
    }
    // Reseñas ocultadas desde el editor del tema (por su código de Judge.me)
    var ocultas = {};
    document.querySelectorAll('[data-zs-ocultar]').forEach(function (el) {
      el.getAttribute('data-zs-ocultar').split(/[\s,]+/).forEach(function (u) { if (u) ocultas[u.toLowerCase()] = 1; });
    });
    cacheResenas[clave] = Promise.all(ids.map(deUno)).then(function (partes) {
      var vistos = {}, reviews = [], n = 0, suma = 0;
      partes.forEach(function (p) {
        n += p.n; suma += p.media * p.n;
        p.reviews.forEach(function (r) {
          if (r.uuid && ocultas[r.uuid.toLowerCase()]) { n -= 1; suma -= parseFloat(r.rating) || 0; return; }
          // Nunca dos veces la misma reseña: ni por id ni por mismo texto + mismo nombre
          var texto = textoPlano(r.body_html).toLowerCase().replace(/[^a-z0-9áéíóúñü֐-׿]/gi, '');
          var k1 = r.uuid || '', k2 = (r.reviewer_name || '').toLowerCase() + '|' + texto;
          if ((k1 && vistos[k1]) || vistos[k2]) return;
          if (k1) vistos[k1] = 1; vistos[k2] = 1;
          reviews.push(r);
        });
      });
      reviews.sort(function (a, b) { return new Date(b.created_at) - new Date(a.created_at); });
      return { reviews: reviews, n: n, media: n ? suma / n : 0 };
    });
    return cacheResenas[clave];
  }

  function initResenasPropias() {
    document.querySelectorAll('[data-zs-resenas]').forEach(function (root) {
      if (root.dataset.zsListo) return;
      root.dataset.zsListo = '1';
      var seccion = root.closest('.zs-resenas');
      var todos = (root.getAttribute('data-producto') || '').split(',').filter(Boolean);
      var seguir = root.getAttribute('data-seguir') === '1';
      var dominio = root.getAttribute('data-tienda');
      var porPagina = Math.max(parseInt(root.getAttribute('data-por-pagina'), 10) || 5, 6);
      var resenas = [], mostradas = 0, mostrarProducto = false, turno = 0;
      var lista = root.querySelector('[data-zs-rev-lista]');
      var prev = root.querySelector('[data-zs-rev-prev]');
      var next = root.querySelector('[data-zs-rev-next]');

      function pintarMas() {
        var hasta = Math.min(resenas.length, mostradas + porPagina);
        for (var i = mostradas; i < hasta; i++) {
          var tarjeta = crearTarjeta(resenas[i]);
          if (mostrarProducto && resenas[i].product_title) {
            var etq = document.createElement('span');
            etq.className = 'zs-rev__producto';
            etq.textContent = resenas[i].product_title;
            var q = tarjeta.querySelector('.zs-rev__quien');
            if (q) q.parentNode.insertBefore(etq, q.nextSibling);
          }
          lista.appendChild(tarjeta);
        }
        mostradas = hasta;
        flechas();
      }
      // Carrusel: se desliza de lado; al acercarse al final se añaden más reseñas
      function paso() { var t = lista.querySelector('.zs-rev__item'); return t ? t.getBoundingClientRect().width + 14 : lista.clientWidth; }
      function flechas() {
        var fin = lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4 && mostradas >= resenas.length;
        if (prev) prev.disabled = lista.scrollLeft <= 4;
        if (next) next.disabled = fin;
      }
      lista.addEventListener('scroll', function () {
        if (mostradas < resenas.length && lista.scrollLeft + lista.clientWidth > lista.scrollWidth - paso() * 2) pintarMas();
        flechas();
      }, { passive: true });
      function mover(dir) {
        if (dir > 0 && mostradas < resenas.length) pintarMas();
        lista.scrollBy({ left: dir * paso(), behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { parar(); mover(-1); });
      if (next) next.addEventListener('click', function () { parar(); mover(1); });

      // Avance automático suave; se detiene en cuanto la clienta toca el carrusel
      var reloj = null, segundos = parseInt(root.getAttribute('data-auto'), 10) || 0;
      function parar() { if (reloj) { clearInterval(reloj); reloj = null; } }
      if (segundos && !(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches)) {
        reloj = setInterval(function () {
          if (!root.isConnected) { parar(); return; }
          if (document.hidden || lista.getBoundingClientRect().bottom < 0) return;
          if (lista.scrollLeft + lista.clientWidth >= lista.scrollWidth - 4 && mostradas >= resenas.length) lista.scrollTo({ left: 0, behavior: 'smooth' });
          else mover(1);
        }, segundos * 1000);
        ['pointerdown', 'wheel', 'touchstart', 'keydown'].forEach(function (ev) { lista.addEventListener(ev, parar, { passive: true }); });
      }

      function fallo() { root.hidden = true; if (seccion) seccion.classList.remove('zs-resenas--propia'); }
      if (!todos.length) { fallo(); return; }

      // Qué producto se ve: el elegido en el selector de compra, o el de la ficha; si no, todos
      function idElegido() {
        var r = document.querySelector('[data-zs-tienda] [data-zs-tc-opcion]:checked');
        return (r && r.getAttribute('data-producto-id')) || root.getAttribute('data-actual') || '';
      }
      function cargar(ids) {
        var mio = ++turno;
        resenasDeProductos(ids, dominio).then(function (d) {
          if (mio !== turno) return;
          // Un producto sin reseñas (p. ej. el pack) muestra las de todos
          if (!d.reviews.length && ids.length < todos.length) { cargar(todos); return; }
          pintar(d, ids);
        }).catch(fallo);
      }
      if (seguir) {
        document.addEventListener('zs:producto', function (e) {
          if (!root.isConnected) return;
          var id = e.detail && e.detail.id;
          cargar(id ? [String(id)] : todos);
        });
        cargar(idElegido() ? [idElegido()] : todos);
      } else {
        cargar(todos);
      }

      function pintar(d, ids) {
        mostrarProducto = root.getAttribute('data-mostrar-producto') === '1' && ids.length > 1;
        resenas = d.reviews.slice();
        if (!resenas.length) { fallo(); return; }
        // Orden: 1) mejor valoradas primero (5★, 4★…); 2) dentro de la misma nota, las que tienen foto; 3) las de español; 4) de la más nueva a la más antigua.
        resenas.forEach(function (r, i) {
          r._nota = parseFloat(r.rating) || 0;
          r._foto = (r.pictures_urls && r.pictures_urls.length) ? 1 : 0;
          r._es = esEspanol(textoPlano(r.body_html) + ' ' + (r.title || ''));
          r._fecha = new Date(r.created_at).getTime() || 0;
          r._i = i;
        });
        resenas.sort(function (a, b) {
          return (b._nota - a._nota) || (b._foto - a._foto) || (a._es === b._es ? 0 : (a._es ? -1 : 1)) || (b._fecha - a._fecha) || (a._i - b._i);
        });
        root.querySelector('[data-zs-rev-cabecera]').innerHTML =
          estrellasHTML(d.media, 'zs-rev__estrellas zs-rev__estrellas--grandes') +
          '<span class="zs-rev__media">' + d.media.toFixed(1).replace('.', ',') + '</span>' +
          '<span class="zs-rev__total">' + d.n + ' ' + (root.getAttribute('data-texto-resenas') || 'reseñas') + '</span>';
        root.hidden = false;
        if (seccion) seccion.classList.add('zs-resenas--propia');
        lista.innerHTML = '';
        mostradas = 0;
        lista.scrollLeft = 0;
        pintarMas();
      }
    });
  }

  /* ---------- Compra con varios productos (zs-tienda) ---------- */
  var RE_COD = /contra\s*-?\s*reembolso|contrareembolso|cash on delivery|\bCOD\b/i;
  function buscarBotonCOD(propio) {
    var candidatos = document.querySelectorAll('button, a, [role="button"], input[type="button"], input[type="submit"]');
    for (var i = 0; i < candidatos.length; i++) {
      var el = candidatos[i];
      if (el.closest('.zs-tc__botones') || el === propio) continue;
      var txt = (el.innerText || el.value || el.getAttribute('aria-label') || '').trim();
      if (txt && RE_COD.test(txt)) return el;
    }
    return null;
  }
  function initTienda() {
    document.querySelectorAll('[data-zs-tienda]').forEach(function (root) {
      if (root.dataset.zsListo) return;
      root.dataset.zsListo = '1';
      var radios = Array.prototype.slice.call(root.querySelectorAll('[data-zs-tc-opcion]'));
      var stock = root.querySelector('[data-zs-stock]');

      function mostrar(idx) {
        root.querySelectorAll('[data-zs-panel]').forEach(function (el) {
          el.hidden = el.getAttribute('data-zs-panel') !== String(idx);
        });
        var r = radios.filter(function (x) { return x.getAttribute('data-zs-tc-opcion') === String(idx); })[0];
        if (stock && r) {
          var n = parseInt(r.getAttribute('data-stock'), 10) || 0;
          var umbral = parseInt(stock.getAttribute('data-umbral'), 10) || 10;
          stock.hidden = n <= 0;
          if (n > 0) {
            var t = stock.querySelector('[data-zs-stock-texto]');
            t.textContent = (t.getAttribute('data-plantilla') || '').replace('[x]', n);
            stock.querySelector('[data-zs-stock-barra]').style.width = Math.max(8, Math.min(100, n / umbral * 100)) + '%';
          }
        }
        // Las reseñas de la página pasan a ser las del producto elegido
        if (r) document.dispatchEvent(new CustomEvent('zs:producto', { detail: { id: r.getAttribute('data-producto-id') } }));
      }
      radios.forEach(function (r) {
        r.addEventListener('change', function () { if (r.checked) mostrar(r.getAttribute('data-zs-tc-opcion')); });
      });
      // Si se llega con ?elegir=<producto> (p. ej. desde un botón de la portada), se marca ese producto
      try {
        var pedido = new URLSearchParams(window.location.search).get('elegir');
        if (pedido) {
          var elegido = radios.filter(function (r) { return r.getAttribute('data-handle') === pedido && !r.disabled; })[0];
          if (elegido) elegido.checked = true;
        }
      } catch (e) {}
      var marcado = radios.filter(function (r) { return r.checked; })[0];
      if (marcado) mostrar(marcado.getAttribute('data-zs-tc-opcion'));

      // Valoraciones reales al momento desde Judge.me (los datos copiados en Shopify pueden ir atrasados)
      var dominio = (window.Shopify && window.Shopify.shop) || location.hostname;
      var todos = (root.getAttribute('data-zs-val-todos') || '').split(',').filter(Boolean);
      function pintarValoracion(el, n, media) {
        if (!n) return;
        var num = el.querySelector('[data-zs-val-num]');
        if (num) num.textContent = n;
        var e = el.querySelector('.zs-estrellas');
        if (e && media) e.style.setProperty('--zs-nota', Math.round(media * 20) + '%');
        el.hidden = false;
      }
      // Cada producto con sus propias valoraciones; si no tiene (p. ej. el pack), las de todos
      root.querySelectorAll('[data-zs-valoracion]').forEach(function (el) {
        resenasDeProductos([el.getAttribute('data-zs-valoracion')], dominio).then(function (d) {
          if (d.n || !todos.length) { pintarValoracion(el, d.n, d.media); return; }
          resenasDeProductos(todos, dominio).then(function (t) { pintarValoracion(el, t.n, t.media); });
        });
      });

      // Galerías: miniaturas y flechas
      root.querySelectorAll('[data-zs-galeria-tc]').forEach(function (g) {
        var principal = g.querySelector('[data-zs-tc-principal]');
        var minis = Array.prototype.slice.call(g.querySelectorAll('[data-zs-tc-mini]'));
        if (!principal || !minis.length) return;
        function ir(i) {
          i = (i + minis.length) % minis.length;
          var b = minis[i];
          principal.src = b.getAttribute('data-src');
          principal.srcset = b.getAttribute('data-srcset');
          principal.alt = b.getAttribute('data-alt');
          minis.forEach(function (m) { m.setAttribute('aria-current', m === b ? 'true' : 'false'); });
        }
        function actual() { var i = minis.findIndex(function (m) { return m.getAttribute('aria-current') === 'true'; }); return i < 0 ? 0 : i; }
        minis.forEach(function (b, i) { b.addEventListener('click', function () { ir(i); }); });
        g.querySelectorAll('[data-zs-tc-flecha]').forEach(function (f) {
          f.addEventListener('click', function () { ir(actual() + parseInt(f.getAttribute('data-zs-tc-flecha'), 10)); });
        });
        var x0 = null;
        principal.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) ir(actual() + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      });

      // Contra reembolso: usa el botón de la app de pago contra reembolso (y lo oculta para que no salga repetido)
      var form = root.querySelector('[data-zs-tc-form]');
      var btnCod = root.querySelector('[data-zs-cod]');
      function ocultarCODapp() {
        var b = buscarBotonCOD(btnCod);
        if (b && root.contains(b)) { b.style.display = 'none'; b.setAttribute('data-zs-cod-app', ''); }
        return b;
      }
      if ('MutationObserver' in window) {
        var mo = new MutationObserver(function () { if (ocultarCODapp()) mo.disconnect(); });
        mo.observe(root, { childList: true, subtree: true });
        setTimeout(function () { mo.disconnect(); }, 15000);
      }
      ocultarCODapp();
      if (btnCod) btnCod.addEventListener('click', function () {
        var app = buscarBotonCOD(btnCod);
        if (app) { app.click(); return; }
        // Sin app visible: añade al carrito y lleva al carrito (allí la app ofrece el contra reembolso)
        btnCod.disabled = true;
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', body: new FormData(form) })
          .then(function () { window.location.href = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart'; })
          .catch(function () { btnCod.disabled = false; form.submit(); });
      });
    });
  }

  /* ---------- Barra de mensajes que rotan (un mensaje cada vez) ---------- */
  function initRotar() {
    document.querySelectorAll('[data-zs-rotar]').forEach(function (root) {
      if (root.dataset.zsListo) return;
      root.dataset.zsListo = '1';
      var msgs = Array.prototype.slice.call(root.querySelectorAll('.zs-rotar__msg'));
      if (msgs.length < 2) { root.querySelectorAll('[data-zs-rotar-paso]').forEach(function (b) { b.hidden = true; }); return; }
      var i = 0, seg = (parseInt(root.getAttribute('data-intervalo'), 10) || 4) * 1000, timer = null;
      function ir(n) {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) { m.hidden = k !== i; });
      }
      function auto() { clearInterval(timer); if (!reduceMotion) timer = setInterval(function () { ir(i + 1); }, seg); }
      root.querySelectorAll('[data-zs-rotar-paso]').forEach(function (b) {
        b.addEventListener('click', function () { ir(i + parseInt(b.getAttribute('data-zs-rotar-paso'), 10)); auto(); });
      });
      auto();
    });
  }

  /* ---------- Antes y después: deslizador ---------- */
  function initComparadores() {
    document.querySelectorAll('[data-zs-comparador]').forEach(function (c) {
      if (c.dataset.zsListo) return;
      c.dataset.zsListo = '1';
      var r = c.querySelector('.zs-ad__rango');
      if (!r) return;
      function pon() { c.style.setProperty('--zs-pos', r.value + '%'); }
      r.addEventListener('input', pon);
      r.addEventListener('change', pon);
      pon();
    });
  }

  // Cada parte arranca por separado: si una falla, las demás siguen funcionando
  function seguro(fn, scope) {
    try { fn(scope); } catch (err) { if (window.console) console.error('[ZelaSkin]', err); }
  }
  function init() {
    [initComparadores, initRotar, initTienda, initResenasPropias, initJudgeme, initReveals, initParallax, initLuces, initProducto, initFaq].forEach(function (fn) { seguro(fn); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // En el editor del tema, al guardar o cambiar ajustes la sección se vuelve a dibujar: se reactiva todo
  document.addEventListener('shopify:section:load', function (e) {
    [initComparadores, initRotar, initTienda, initResenasPropias, initLuces, initProducto, initFaq].forEach(function (fn) { seguro(fn); });
    seguro(initReveals, e.target);
  });
})();
